import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.StatsByLabelView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'stats-by-label'
  name: 'stats-by-label-table'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  chartClass: 'stats-by-label-table'

  render: ->
    @columns = @getTemplateOptions().columns
    @specific_settings ||= {}

    @specific_settings.benchmark = true
    @$el.html(@template(self: this))
    @bindChartsReady(1)
    @_getTable().addClass('processing')
    query = @labelsQuery(@labelFilter(), @labelsStructure())
    rowColorOption = @getTemplateOptions().rows
    fb_page = @getTemplateOptions().page

    @setBenchmarkSettingsIfNecessary(query)
    $.post(@options.chartApi.posts_by_label + @getTemplateOptions().network, _.extend({page: fb_page}, query, @getExtraQuery()), (response) =>
      tableData = { columns: @columns, data: [], types: ['string', 'number', 'number', 'number', 'string'], options: {} }
      for label in response
        tableData.data.push([label["name"], label["posts"], label["reach"], label["interactions"], label["egmnt"]])
      @_getTable().html(new Monitoring.Reports.Executive.TableView(response: tableData).render().el)
    )
    return this

  _getTable: ->
    @$el.find(".#{@chartClass}")
